








import Vue from "vue";
import { LTooltip } from "vue2-leaflet";
import { point, TooltipOptions } from "leaflet";
import Component from "vue-class-component";

const TagComponentProps = Vue.extend({
  props: {
    content: String,
    show: {
      type: Boolean,
      default: false,
    },
    textColor: {
      type: String,
      default: "yellow",
    },
    fontSize: {
      type: String,
      default: "10",
    },
  },
});

@Component({
  components: {
    LTooltip,
  },
})
export default class TagComponent extends TagComponentProps {
  tooltip: any = null;

  $refs!: {
    tooltip: any;
  };
  //computed
  get options():TooltipOptions {
    return {
      permanent: this.show,
      className: "own",
      offset: point(0, -0.1),
      sticky: true
    }
  }
  get cssColor() {
    return {
      "--text-color": this.textColor,
      "--text-size": this.fontSize + "pt",
    };
  }

  mounted() {
    this.$nextTick(() => {
      this.tooltip = this.$refs.tooltip.mapObject;
    });
  }
  beforeDestroy() {
    this.tooltip.remove();
  }
}
